import { useState } from "react";
import { Col, Container, Form, Modal, Row, Button } from "react-bootstrap";

export const DocumentInfoModal = ({
  product,
  documentName,
  fetchDocument,
  show,
  handleClose,
}) => {
  const [optionSelect, setOptionSelect] = useState("blank");

  return (
    <Modal size="lg" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Process Document Generator: Data Review for{" "}
          <span className="fw-bold">
            {documentName} for VID{product?.v_id}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="productName">
                <Form.Label className="fw-bold">Product Name</Form.Label>
                <p className="px-2">{product?.product_name}</p>
              </Form.Group>
              <Form.Group controlId="options">
                <Form.Label className="fw-bold">Options:</Form.Label>
                <Form.Check
                  type="radio"
                  label="Signature Line Blank"
                  name="options"
                  value={true}
                  onChange={() => setOptionSelect("blank")}
                  id="options1"
                />
                <Form.Check
                  type="radio"
                  label="Add “Original Signed by”"
                  name="options"
                  value={true}
                  onChange={() => setOptionSelect("final")}
                  id="options2"
                />
                <Form.Check
                  type="radio"
                  label="Add Draft Watermark"
                  name="options"
                  value={false}
                  onChange={() => setOptionSelect("watermark")}
                  id="options3"
                />
              </Form.Group>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="warning" onClick={handleClose}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            fetchDocument(documentName, true, optionSelect);
          }}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
